import { useEffect } from "react";
import { useStore } from "zustand";
import attendclientStore from "@data/stores/attendClient";
import { WatchTableAttendClientsUseCase } from "@useCases/index";
import { Filter } from "@domain/models/Filters";
import { Paging } from "@domain/models/Paging";
import { FirebaseAttendClientRepository } from "@data/repositories/index";
import userStore from "@data/stores/user";

type Props = {
  filters: Filter[];
  paging: Paging;
};

export default function useTableAttendClients({ filters, paging }: Props) {
  const { dashboardTable, dashboardTableTotal } = useStore(attendclientStore);

  const getTableAttendClients = async () => {
    const useCase = new WatchTableAttendClientsUseCase(
      userStore.getState(),
      new FirebaseAttendClientRepository(attendclientStore.getState())
    );

    useCase.execute({ paging });
  };

  useEffect(() => {
    if (dashboardTable.length === 0) {
      getTableAttendClients();
    }
  }, []);

  useEffect(() => {
    if (filters.length === 0) {
      getTableAttendClients();
    }
  }, [paging]);

  return {
    tableAttendClients: dashboardTable.slice(paging.offset, paging.offset + 25),
    tableAttendClientsTotal: dashboardTableTotal,
  };
}
